// removed by extract-text-webpack-plugin
module.exports = {"container":"_3M8zTNm1PFzS88PObX07LL","barLeft":"pw_Gfto1EG2lLL-ADGj_a","iconTop":"_1F5Io2ZpyW8tG4YWiYR7m1","textV":"NqXBbJtHLD3wgbrQH-t-r","actionIcon":"_34RInLdeLNF1LunlbGM5ZK","content":"_31Pm5r_3w1oqKNO4xU-ACP","date":"_2-0HKJu__OENlK80je3ymi","title":"eNX1YtAOYHqZcX4e8iCAq","location":"_2sWC3kxQP7Ngc2C47G3oYa","city":"_2xUCnIsZT9mjs9n7UaDwC6","body":"_2SpZslQCHvqIS0V5_y1RA-","spam":"_22z6Wh5F_esgWFer97oNRs","item":"_2dnBUwRwp8z0xNASd859Fv","listMembers":"_2F2LLVyy-i9SXCHoGj27w1"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Components/Add/style.css
// module id = 416
// module chunks = 37